module.exports = __webpack_public_path__ + "img/symbol-swan-center.c45a9775.png";